@for (name of visibleNames(); track $index) {
    <span class="avatar" [class.last]="showFadeOutEffect() && $last">
        <app-cerrix-avatar class="clickable" [name]="name" (click)="addRequested.emit()" />
    </span>
}
@if (hiddenNames().length && readonly()) {
    <span class="avatar">
        <span class="more" [title]="hiddenTitle()">+{{ hiddenNames().length }}</span>
    </span>
}
@if (showAddButton()) {
    <button
        class="add"
        type="button"
        [attr.aria-label]="addLabel() || ('cerrix-avatar-group.addLabel' | transloco)"
        [title]="addLabel() || ('cerrix-avatar-group.addLabel' | transloco)"
        (click)="addRequested.emit()"
    >
        <app-cerrix-avatar icon="add-user" />
    </button>
}
@if (!names().length && !showAddButton()) {
    <span class="empty">{{ emptyText() || ("cerrix-avatar-group.emptyText" | transloco) }}</span>
}
